document.addEventListener('DOMContentLoaded', function() {
  if (window.innerWidth < 1024) return; // 仅 PC

  // 使用 MutationObserver 确保 ul.eg-ksp 已经渲染
  var observer = new MutationObserver(function(mutations, obs) {
    var mediaCards = document.querySelectorAll('.media');

    mediaCards.forEach(function(media) {
      var ksp = media.querySelector('ul.eg-ksp');
      if (!ksp || ksp.dataset.bound === 'true') return; // 已绑定跳过

      ksp.dataset.bound = 'true'; // 标记已绑定

      // 标记阻止原 hover
      media.dataset.hoverBlocked = 'false';

      // 鼠标进入 ul.eg-ksp
      ksp.addEventListener('mouseenter', function() {
        media.dataset.hoverBlocked = 'true';
      });

      // 鼠标离开 ul.eg-ksp
      ksp.addEventListener('mouseleave', function() {
        media.dataset.hoverBlocked = 'false';

        // Flickity 切换
        if (media.flickityInstance) {
          media.flickityInstance.next();
          return;
        }

        // 普通多图切换
        var imgs = media.querySelectorAll('img');
        if (imgs.length > 1) {
          var currentIndex = Array.from(imgs).findIndex(img => img.style.display !== 'none');
          imgs[currentIndex].style.display = 'none';
          var nextIndex = (currentIndex + 1) % imgs.length;
          imgs[nextIndex].style.display = 'block';
        }
      });

      // 阻止原 hover 逻辑
      media.addEventListener('mouseenter', function(e) {
        if (media.dataset.hoverBlocked === 'true') e.stopImmediatePropagation();
      });
    });

    // 解绑 observer，如果已经找到 ul.eg-ksp 就可以停止
    // obs.disconnect();
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
